export var SpaceType;
(function (SpaceType) {
    SpaceType["UNIT"] = "listing";
    SpaceType["AMENITY"] = "amenity";
})(SpaceType || (SpaceType = {}));
export var SpacePMSStatus;
(function (SpacePMSStatus) {
    SpacePMSStatus["SYNCED"] = "synced";
    SpacePMSStatus["LOADING"] = "loading";
    SpacePMSStatus["FAILED"] = "failed";
    SpacePMSStatus["UNAVAILABLE"] = "unavailable";
})(SpacePMSStatus || (SpacePMSStatus = {}));
